import * as ServiceCustomer from '../services/customers';
import Vue from 'vue';
import store from '../store';
import i18n from '../translations'

function checkCustomerByTerm(customer, loweredTerm) {
    return customer.vat && customer.vat.toLowerCase().includes(loweredTerm)
        || (customer.cardCode && customer.cardCode.toLowerCase().includes(loweredTerm))
        || (customer.company && customer.company.toLowerCase().includes(loweredTerm))
        // Search for term inside all keys of shipping
        || (Object.values(customer).join(' ').toLowerCase().includes(loweredTerm))
}
// function checkCustomerByOwner (customer, slpCode) {
//             return customer.vat )}
function checkCustomerBySlpCode(customer, currentSlpCode) {
    return customer.slpCode.toLowerCase().includes(currentSlpCode.toLowerCase())
}
function checkCustomerByProvince(customer, province) {

    return customer.province.toLowerCase().includes(province.toLowerCase())
}
export default {
    namespaced: true,
    state: {
        customer: {},
        customers: [],
        countryList: [],
        customersTotal: 0,
        currentPage: 1,
        pageSize: 12,
        searchTerm: '',
        searchProvince: '',
        searchCountry: '',
        searchSlpCode: '',
        customerLoading: false,
    },
    actions: {
        async getCustomers(context) {
            let searchField = context.rootState.customers.searchTerm;
            let cardCode = "";
            let userText = context.rootState.customers.searchSlpCode;
            let pageSize = context.rootState.customers.pageSize;
            let stateFilter = context.rootState.customers.searchProvince;
            let currentPage = context.rootState.customers.currentPage;
            let countPage = "";
            let countryFilter = context.rootState.customers.searchCountry;

            context.commit('customerLoading', true);
            let response = await ServiceCustomer.getCustomerFilter(searchField, cardCode, userText, pageSize, countryFilter, stateFilter, currentPage, countPage)
                .then(response => {
                    context.commit('setCustomers', []);
                    context.commit('setCustomers', response.data.customerByFilterCollection.allCustomerFilterData);
                    context.commit('setCustomersTotal', parseInt(response.data.customerByFilterCollection.allInformationCustomerFilter[0].counter));
                }).catch(response => {
                    console.log(response)
                });
            context.commit('customerLoading', false);
        },
        async getCustomer(context) {
            let cardCode = context.rootState.cart.order.customer.cardCode
            let response = await ServiceCustomer.getCustomers(cardCode);
            if (response.data) {
                context.commit('setCustomer', response.data.customerByCardCode.allCustomerData[0]);
            } else {
                console.log(response)
            }
        },
        async getCurrentCustomer(context) {
            let cardCode = context.rootState.cart.order.customer.cardCode;
            let userId = context.rootState.auth.user.ownerCode;
            let response = await ServiceCustomer.getCustomers(cardCode,userId);
            if (response.data) {
                context.commit('setCustomer', response.data.customerByCardCode.allCustomerData[0]);
                store.commit('cart/setCustomerData', response.data.customerByCardCode.allCustomerData[0]);
                store.commit('auth/setPaymentCustomer', response.data.customerByCardCode.allCustomerData[0].defaultPayment);
                store.commit('currency/setCurrency', response.data.customerByCardCode.allCustomerData[0].defaultCurrency);
            } else {
                console.log(response)
            }
            return [];
        },
        async addCustomerShipping(context, data) {
            let cardCode = context.rootState.cart.order.customer.cardCode;
            let customerId = context.rootState.cart.order.customer.customerId;
            let response = await ServiceCustomer.setAddressForm(data, cardCode, customerId);
            if (response.data) {
                if (response.data.addressFormSubmit.shipping[0].response !== "success") {
                    Vue.notify({
                        group: 'error',
                        title: `${ i18n.t('customer.addressNotAdded') }`,
                        text: response.data.addressFormSubmit.shipping[0].response
                    });
                    // throw new Error();
                } else {
                    Vue.notify({
                        group: 'success',
                        title: `${ i18n.t('customer.addressAdded') }`,
                        text: ""
                    });
                    context.commit('addCustomerShipping', response.data.addressFormSubmit.shipping[0]);
                }
            } else {
                console.log(response);
            }
        },
        async updateCustomerShipping(context, data) {
            let cardCode = context.rootState.cart.order.customer.cardCode;
            let customerId = context.rootState.cart.order.customer.customerId;
            let response = await ServiceCustomer.setAddressForm(data,cardCode,customerId);
            if (response.data) {
                if (response.data.addressFormSubmit.shipping[0].response !== "success") {
                    Vue.notify({
                        group: 'error',
                        title: `${ i18n.t('customer.addressNotUpdated') }`,
                        text: response.data.addressFormSubmit.shipping[0].response
                    });
                } else {
                    Vue.notify({
                        group: 'success',
                        title: `${ i18n.t('customer.addressUpdated') }`,
                        text: ""
                    });
                    context.commit('updateCustomerShipping', data);
                }
            } else {
                console.log(response);
            }
        },
    },
    getters: {
        customerLoading: (state) => {
            return state.customerLoading;
        },
        shipping: (state) => {
            return state.customer.shipping;
        },
        customers: (state) => {
            return state.customers;
        },
        billing: (state) => {
            return state.customer.billing;
        },
        cardCode: (state) => {
            return state.customer.cardCode;
        },
        customersFiltering: (state, getters, rootState) => {
            return state.customers.reduce((acc, customer) => {
                return acc;
            }, [])
        },
        customersFilterByProvince: (state, getters) => {
            if (state.searchProvince && state.searchProvince != '00') {
                // var result = StateList.filter(function(elem){
                //     return elem.code == state.searchProvince 
                // })
                return getters.customers.filter(customer => checkCustomerByProvince(customer, state.searchProvince))
            } else {
                return getters.customers;
            }
        },
        customersFilteredBySalesPerson: (state, getters) => {
            if (state.searchSlpCode) {
                return getters.customers.filter(customer => checkCustomerBySlpCode(customer, state.searchSlpCode))
            } else {
                return getters.customers;
            }
        },
        customersFilteredByTerm: (state, getters) => {
            let customer = [];
            customer = getters.customers;
            return customer;
        },
        processedCustomers: (state, getters) => {
            // let index = (state.currentPage - 1) * state.pageSize;
            return getters.customersFilteredByTerm.slice(0, 0 + state.pageSize);
        },
        processedCustomersTotal: (state, getters) => {
            return state.customersTotal;
        },
        customerPageCount: (state, getters) => {
            return Math.ceil(getters.processedCustomersTotal / state.pageSize);
        },
        shippingPageCount: (state, getters) => {
            return (getters.customers.length > 0) ? getters.customers.length : 0;
        },
    },
    mutations: {
        customerLoading(state, newLoading) {
            state.customerLoading = newLoading;
        },
        setCustomer(state, customer) {
            state.customer = customer;
        },
        updateCustomerShipping(state, data) {
            let updatedShipping = state.customer.shipping.find(shipping => shipping.addressId === data.addressId);
            Object.keys(updatedShipping).forEach(key => {
                if (data[key] !== undefined) {
                    updatedShipping[key] = data[key];
                }
            });
        },
        addCustomerShipping(state, data) {
            state.customer.shipping.push(data);
        },
        setCustomers(state, customer) {
            state.customers = customer;
        },
        setCustomerData(state, data) {
            state.customers = data.cusData.sort();
            state.customersTotal = data.cusData.length();
        },
        setCustomersTotal(state, customersNumber) {
            state.customersTotal = customersNumber;
        },
        setCurrentPage(state, page) {
            state.currentPage = page;
            this.dispatch('customers/getCustomers');
        },
        setPageSize(state, size) {
            state.pageSize = size;
            state.currentPage = 1;
            this.dispatch('customers/getCustomers');
        },
        setSearchTerm(state, term) {
            state.searchTerm = term;
            state.currentPage = 1;
            this.dispatch('customers/getCustomers');
        },
        setSearchProvince(state, province) {
            state.searchProvince = province;
            state.currentPage = 1;
            this.dispatch('customers/getCustomers');
        },
        setSearchCountry(state, country) {
            state.searchCountry = country;
            state.currentPage = 1;
            this.dispatch('customers/getCustomers');
        },
        setSlpCode(state, valueInput) {
            if (valueInput.checked) {
                state.searchSlpCode = "18";
                state.currentPage = 1;
            } else {
                state.searchSlpCode = "";
                state.currentPage = 1;
            }
            this.dispatch('customers/getCustomers');
        },
    },
}
